<template>
  <img
    :src="src"
    :class="[
      $style.thumbnail,
      { [$style['thumbnail--noDiagnosis']]: personalityType === undefined },
    ]"
  />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'

import ImageType1 from '@/assets/images/diagnosis-type01.png'
import ImageType2 from '@/assets/images/diagnosis-type02.png'
import ImageType3 from '@/assets/images/diagnosis-type03.png'
import ImageType4 from '@/assets/images/diagnosis-type04.png'
import ImageType5 from '@/assets/images/diagnosis-type05.png'
import ImageType6 from '@/assets/images/diagnosis-type06.png'
import ImageType7 from '@/assets/images/diagnosis-type07.png'
import ImageType8 from '@/assets/images/diagnosis-type08.png'
import ImageDefault from '@/assets/images/no-diagnosis-user.png'

import type { PersonalityType } from '@/types/app'

const diagnosisImages: Record<PersonalityType, string> = {
  A: ImageType1,
  B: ImageType2,
  C: ImageType3,
  D: ImageType4,
  E: ImageType5,
  F: ImageType6,
  G: ImageType7,
  H: ImageType8,
}

export default defineComponent({
  name: 'UserThumbnail',
  props: {
    personalityType: {
      type: String as PropType<Maybe<PersonalityType>>,
      default: undefined,
    },
  },
  setup(props) {
    const src = computed((): string => {
      return props.personalityType !== undefined
        ? diagnosisImages[props.personalityType]
        : ImageDefault
    })
    return { src }
  },
})
</script>

<style lang="scss" module>
.thumbnail {
  background-color: $color-surface-accent-primary;
  border-radius: 999em;
  object-fit: contain;

  &--noDiagnosis {
    background-color: initial;
  }
}
</style>
